import { createRoot } from '../../utils/react-shim'

import { SiteSearch } from '../SiteSearch'

// Declare it as as web component
export class SiteSearchElement extends HTMLElement {
  connectedCallback() {
    const root = createRoot(this)
    root.render(<SiteSearch />)
  }
}
